module.exports = __webpack_public_path__ + "images/project-welcome-a5b023e1e08c518cf28dec3cdf82aacd.svg";